import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../../Services/translation';
import { cn } from '../../../Utils/cn';
import {
  setSignUp,
  setBonus,
  signUpForEnjoy,
} from '../../../Actions/Checkout.action';
import { post } from '../../../Services/http';

const CheckoutEnjoyClubCollapse = ({ checkout, cart }) => {
  const dispatch = useDispatch();
  const { payload } = checkout || {};
  const {
    bonusImage: image,
    enjoyClubDescription: description,
    errorMessage,
    isBusinessCustomer,
    authenticated,
    isInEnjoyClub,
    signedUpForEnjoy: wantsToJoinEnjoyClub,
    signUp: wantsToSignUp,
    loginUrl,
    bonusBalance,
    bonusToEarn,
    bonusUsed,
  } = payload || {};

  const [loading, setLoading] = useState(false);
  const [bonusSubmitted, setBonusSubmitted] = useState(false);
  const [bonusValue, setBonusValue] = useState('');

  useEffect(() => {
    if (!authenticated && wantsToSignUp != false) {
      dispatch(setSignUp(false));
    }
  }, [authenticated, wantsToSignUp, dispatch]);

  const handleSignUpForEnjoy = useCallback(async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await post('/api/enjoyClub/signUp');
      window.location.reload();
    } catch (error) {
      window.location.reload();
    }
  }, [loading]);

  const handleSignUpToggle = useCallback(() => {
    dispatch(signUpForEnjoy(!wantsToJoinEnjoyClub));
  }, [wantsToJoinEnjoyClub, dispatch]);

  const handleBonusChange = useCallback((event) => {
    setBonusValue(event?.target?.value);
  }, []);

  const handleBonusSubmit = useCallback(
    (event) => {
      event.preventDefault();
      setBonusSubmitted(true);
      setBonusValue('');
      dispatch(setBonus(Math.abs(Number(bonusValue))));
    },
    [bonusValue, dispatch]
  );

  if (isBusinessCustomer) {
    return null;
  }

  return (
    <div className="checkout-section !bg-background-tertiary grid gap-8 md:grid-cols-4">
      <img
        className="w-full max-w-16 md:max-w-none"
        src={image}
        alt="Enjoy Club"
      />
      <div className="md:col-span-3">
        <h2 className="heading-2 mb-4 font-bold last:mb-0">
          {translate(
            isInEnjoyClub
              ? 'checkout.loyalty.heading.member'
              : 'checkout.loyalty.heading.join'
          )}
        </h2>
        <p className="body-sm mb-4 font-bold last:mb-0">
          {translate('checkout.bonus.canget')}
          {': '}
          <span className="ml-[0.125em] text-[1.75em] leading-none">
            {cart?.bonusToEarn ?? bonusToEarn} {translate('checkout.points')}
          </span>
        </p>
        {isInEnjoyClub ? (
          <div>
            <p className="body mb-4">
              {translate('checkout.cart.bonus.your_points')}
              {': '}
              {bonusBalance} {translate('checkout.points')}
            </p>
            <form onSubmit={handleBonusSubmit} className="flex items-end gap-2">
              <div className="flex-1">
                <label
                  htmlFor="bonus-amount"
                  className="body-sm leading-base text-label mb-1 inline-block"
                >
                  {translate('checkout.cart.bonus.amount_label')}
                </label>
                <input
                  id="bonus-amount"
                  className="form__input no-number-spinner"
                  type="number"
                  value={bonusValue}
                  onChange={handleBonusChange}
                  required
                />
              </div>
              <input
                type="submit"
                className="button"
                value={translate('checkout.cart.bonus.use_button')}
              />
            </form>
            {(bonusSubmitted || bonusUsed !== 0 || cart?.bonusUsed !== 0) && (
              <p className="body mt-4">
                {translate('checkout.cart.bonus.used')}
                {': '}
                {Math.abs((cart?.bonusUsed ?? bonusUsed) || 0)}
              </p>
            )}
          </div>
        ) : (
          <>
            {!!description?.value && (
              <div
                className={cn('rich-text mb-4 last:mb-0')}
                dangerouslySetInnerHTML={{
                  __html: description.value,
                }}
              />
            )}
            {authenticated ? (
              <button
                className="button relative disabled:cursor-wait disabled:text-transparent"
                onClick={handleSignUpForEnjoy}
                disabled={loading}
              >
                {translate('checkout.bonus.signup')}
                {loading && (
                  <span
                    className={cn(
                      '-translate-1/2 icon animate-hourglass-flip pointer-events-none absolute left-1/2 top-1/2 text-white'
                    )}
                  >
                    hourglass
                  </span>
                )}
              </button>
            ) : (
              <>
                <div className="mb-4">
                  <label
                    htmlFor="signUpForEnjoy"
                    className="inline-flex items-start gap-2"
                  >
                    <input
                      id="signUpForEnjoy"
                      className="mt-1"
                      type="checkbox"
                      checked={wantsToJoinEnjoyClub}
                      onChange={handleSignUpToggle}
                    />
                    <span>{translate('checkout.bonus.signup')}</span>
                  </label>
                </div>
                <div>
                  <a className="button" href={loginUrl}>
                    {translate('checkout.bonus.signin')}
                  </a>
                </div>
              </>
            )}
          </>
        )}
        {errorMessage && <p className="body text-error mt-4">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default CheckoutEnjoyClubCollapse;
